import React from "react";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import PastPerformances from "components/PastPerformances";
import TabTables from "components/TabTables";
import Workouts from "./Workouts";
import Scratches from "./Scratches/Scratches";

export interface Props {
  horse: racehorse360.IHorse;
  rootRef: any;
}

const VetActivity = (props: Props) => {
  const { horse, rootRef } = props;

  const theme = useTheme();
  const matchesUpMd = useMediaQuery(theme.breakpoints.up("md"), {
    noSsr: true
  });

  return (
    <TabTables
      defaultOpen={1}
      tabs={[
        {
          name: "PPs",
          component: (
            <PastPerformances
              horse={horse}
              pagination={matchesUpMd}
              isSliderOnMobile
              rootRef={rootRef}
            />
          )
        },
        {
          name: "Workouts",
          component: (
            <Workouts
              horse={horse}
              pagination={matchesUpMd}
              isSliderOnMobile
              rootRef={rootRef}
            />
          )
        },
        {
          name: "Scratches",
          component: (
            <Scratches
              pagination={matchesUpMd}
              isSliderOnMobile
              rootRef={rootRef}
              horse={horse}
            />
          )
        }
      ]}
    />
  );
};

export default VetActivity;
